module.exports = __webpack_public_path__ + "img/banner-pet0.a6947129.jpg";